module.exports = "<div *ngIf=\"message\"\n     [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">\n    {{message.text}}\n</div>\n<div *ngIf=\"message\"\n     [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">\n    Yes yes\n</div>"


//////////////////
// WEBPACK FOOTER
// ./public/app/_directives/alert.component.html
// module id = ./public/app/_directives/alert.component.html
// module chunks = main